
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"800","height":"800","viewBox":"0 0 24 24","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M16.069 9H7.93c-.606 0-.908 0-1.049.12a.5.5 0 00-.173.42c.014.183.228.397.657.826l4.068 4.068c.198.198.297.297.411.334.1.033.209.033.31 0 .114-.037.213-.136.41-.334l4.07-4.068c.428-.429.642-.643.656-.827a.5.5 0 00-.174-.42C16.977 9 16.674 9 16.07 9z","stroke":"#000","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    